import { useRef, useState } from "react";
import { Camera, Loader2 } from "lucide-react";
import { compressImage } from "@/lib/image";

// Tap-to-upload circular avatar with instant preview + client-side compression.
// value = image data URL / URL (or empty). onFile = (dataUrl:string) => void.
export default function AvatarUpload({ value, onFile, testid = "avatar-upload", label = "Add photo", maxDim = 512 }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const url = await compressImage(file, { maxDim });
      onFile(url);
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="flex items-center gap-4">
      <button
        type="button"
        onClick={() => ref.current?.click()}
        className="group relative h-20 w-20 shrink-0 rounded-full border-2 border-dashed border-border bg-accent/40 overflow-hidden flex items-center justify-center transition-colors hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary"
        data-testid={testid}
        aria-label={label}
      >
        {busy ? (
          <Loader2 size={22} className="animate-spin text-primary" />
        ) : value ? (
          <>
            <img src={value} alt="" className="h-full w-full object-cover" />
            <span className="absolute inset-0 bg-black/45 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
              <Camera size={20} className="text-white" />
            </span>
          </>
        ) : (
          <Camera size={22} className="text-muted-foreground group-hover:text-primary transition-colors" />
        )}
      </button>
      <div className="min-w-0">
        <p className="text-sm font-medium">{value ? "Photo added" : label}</p>
        <button type="button" onClick={() => ref.current?.click()} className="text-xs text-primary hover:underline" data-testid={`${testid}-cta`}>
          {value ? "Tap to change" : "Tap the circle to upload"}
        </button>
      </div>
      <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
